export const SESSION_STORAGE_KEYS = {
  NO_REFERENCE_WARNING_SHOWN: "no_reference_warning_shown",
};

export const SessionStorage = {
  setItem: (key: string, value: string): void => {
    if (typeof window !== "undefined") {
      try {
        window.sessionStorage.setItem(key, value);
      } catch (error) {
        // Silent fail
      }
    }
  },

  getItem: (key: string): string | null => {
    if (typeof window !== "undefined") {
      try {
        return window.sessionStorage.getItem(key);
      } catch (error) {
        return null;
      }
    }
    return null;
  },

  removeItem: (key: string): void => {
    if (typeof window !== "undefined") {
      try {
        window.sessionStorage.removeItem(key);
      } catch (error) {
        // Silent fail
      }
    }
  },
};
